import { useTranslation } from 'react-i18next';

const RecordsHero = () => {
  const { t } = useTranslation();

  return (
    <section className="relative bg-leather-dark pt-28 pb-16 sm:pt-40 sm:pb-32">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
        {/* Logo Image */}
        <div className="mb-8 sm:mb-12">
          <img 
            src="https://static.readdy.ai/image/f407d1ad302e1be1c54e67247a4ef201/fc37a17fc72207c7448b16701106f8db.png" 
            alt="Anson Road Records Logo" 
            className="w-full max-w-md sm:max-w-2xl mx-auto h-auto"
          />
        </div>

        {/* Title */}
        <h1 className="font-display text-3xl sm:text-5xl md:text-7xl font-black text-cream mb-6 sm:mb-8 uppercase leading-tight">
          {t('records.hero.title')}
        </h1>
        <div className="w-16 sm:w-24 h-1 bg-orange-burnt mx-auto mb-8 sm:mb-12"></div>

        {/* Intro */}
        <p 
          className="font-sans text-base sm:text-xl md:text-2xl text-cream/90 leading-relaxed max-w-3xl mx-auto mb-10 sm:mb-16"
          dangerouslySetInnerHTML={{ __html: t('records.hero.intro') }}
        />

        {/* What We Release */}
        <div className="bg-cream/5 border-2 border-cream/20 p-6 sm:p-12">
          <h2 className="font-western text-xl sm:text-3xl font-bold text-orange-burnt mb-6 sm:mb-8 uppercase">
            {t('records.hero.whatWeRelease')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 text-left">
            <div className="flex items-start gap-3 sm:gap-4">
              <i className="ri-checkbox-circle-fill text-xl sm:text-2xl text-orange-burnt mt-1 flex-shrink-0"></i>
              <p 
                className="font-sans text-sm sm:text-lg text-cream/80 font-bold"
                dangerouslySetInnerHTML={{ __html: t('records.hero.texasCountry') }}
              />
            </div>
            <div className="flex items-start gap-3 sm:gap-4">
              <i className="ri-checkbox-circle-fill text-xl sm:text-2xl text-orange-burnt mt-1 flex-shrink-0"></i>
              <p 
                className="font-sans text-sm sm:text-lg text-cream/80"
                dangerouslySetInnerHTML={{ __html: t('records.hero.altCountry') }}
              />
            </div>
            <div className="flex items-start gap-3 sm:gap-4">
              <i className="ri-checkbox-circle-fill text-xl sm:text-2xl text-orange-burnt mt-1 flex-shrink-0"></i>
              <p 
                className="font-sans text-sm sm:text-lg text-cream/80"
                dangerouslySetInnerHTML={{ __html: t('records.hero.borderland') }}
              />
            </div>
            <div className="flex items-start gap-3 sm:gap-4">
              <i className="ri-checkbox-circle-fill text-xl sm:text-2xl text-orange-burnt mt-1 flex-shrink-0"></i>
              <p 
                className="font-sans text-sm sm:text-lg text-cream/80"
                dangerouslySetInnerHTML={{ __html: t('records.hero.crossover') }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecordsHero;
